module.exports = __webpack_public_path__ + "static/main_logo-01a75ab573cdee1e41d2a2094df48b5f.svg";